<script>
import PtIcon from '@patsnap-biz/icon';

const CLASS_NAME = 'patsnap-biz-header-widget';

function classname(chain = []) {
    return [CLASS_NAME, ...chain].join('__');
}

export default {
    functional: true,
    components: {
        PtIcon,
    },
    render(h, { props, data }) {
        const {
            icon, label, postIcon, href,
        } = props;
        const Comp = {
            functional: true,
            render(c, { data: attrs, children }) {
                return c(href ? 'a' : 'div', attrs, children);
            },
        };
        const onlyIcon = !label && (icon || postIcon);
        return <Comp {...data} class={[classname(), { [`${CLASS_NAME}--only-icon`]: onlyIcon }]}>
            { icon ? <PtIcon
                icon={icon}
                class={classname(['pre-icon'])}
            /> : null }
            { label ? <span class={classname(['content'])}>
                { label }
            </span> : null }
            { postIcon ? <PtIcon
                icon={postIcon}
                class={classname(['post-icon'])}
            /> : null}
        </Comp>;
    },
};
</script>
